export default (val, row, col) => {
  const value = Number(val) || val;
  const classList = [];
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) {
    return { value, classList };
  }
  if (row + 2 === col || val === '') {
    classList.push('grey');
  } else if (value > 0.5) {
    classList.push('darkGreen');
  } else if (value > 0 && value <= 0.5) {
    classList.push('lightGreen');
  } else if (value < 0 && value <= -0.5) {
    classList.push('darkRed');
  } else if (value > -0.5) {
    classList.push('lightRed');
  }
  classList.push('numericValues');

  return { value, classList };
};
